export default {"src":"/pro/_next/static/media/squid-logo.0ea58104.svg","height":14,"width":26,"blurWidth":0,"blurHeight":0};